<template src="@/templates/office/contactUs.html"></template>

<script>
import { mapActions } from "vuex";
import contactUsModel from "@/models/contactUsModel";

export default {
  name: "contactUs",
  data() {
    return {
      contactUsModel: new contactUsModel(),

      headOfficeAddress: "Unit 9, 51-55 City Road Southbank VIC 3006",
      helpDeskEmail: "helpdesk@allgraduates.com.au",
      payablesEmail: "payables@allgraduates.com.au",
      redirectRequest: "https",
      contactUsHTML: "",
    };
  },
  created: function () {
    this.initialSetup();
    this.getContactUs();
  },
  methods: {
    ...mapActions(["updateHideAll"]),
    initialSetup() {
      this.updateHideAll();
    },

    getContactUs() {
      let thiz = this;
      this.$vs.loading();
      this.contactUsModel
        .getContactUs()
        .then((res) => {
          if (res) {
            if (res.response.data) {
              let result = res.response.data;
              console.log("HOOYY", result);
              thiz.contactUsHTML = result.data.contact_us;
            }
          }

          thiz.$vs.loading.close();
        })
        .catch((error) => {
          thiz.$vs.loading.close();
          console.log(error);
        });
    },
    openMaps() {
      /* if we're on iOS, open in Apple Maps */
      if (
        navigator.platform.indexOf("iPhone") != -1 ||
        navigator.platform.indexOf("iPad") != -1 ||
        navigator.platform.indexOf("iPod") != -1
      ) {
        this.redirectRequest = "maps";
      } else {
        /* else use Google */
        this.redirectRequest = "https";
      }

      window.open(
        this.redirectRequest +
          "://maps.google.com/maps/dir/?api=1&destination=" +
          this.headOfficeAddress
      );
    },
  },
};
</script>

<style scoped>
.linkMaps,
.linkMaps:visited {
  color: blue !important;
  text-decoration: underline !important;
  cursor: pointer !important;
}

.linkMaps:active,
.linkMaps:visited:active {
  color: blue !important;
}
</style>
